
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { DrillLinkedService } from 'app/model/linkedservice/drill.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'DrillTable',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Drill_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Drill_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: DrillLinkedService.MODEL // Linked service redefined
        }
    }
})
export class DrillTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
